import { createContext, useContext, useEffect, useRef } from "react";
import Lenis from "lenis";
import { gsap, ScrollTrigger } from "@/motion/gsapSetup";

// Espone il ref all'istanza Lenis (per scrollTo, reset su cambio pagina, ecc.)
const LenisContext = createContext({ current: null });
export const useLenisRef = () => useContext(LenisContext);

function prefersReduced() {
  return typeof window !== "undefined" && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
}

// Smooth scroll (Lenis) sincronizzato con GSAP ScrollTrigger.
// Su prefers-reduced-motion resta lo scroll nativo, senza inizializzare Lenis.
export function SmoothScrollProvider({ children }) {
  const lenisRef = useRef(null);

  useEffect(() => {
    if (prefersReduced()) return;

    const lenis = new Lenis({
      duration: 1.05,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
      smoothWheel: true,
      wheelMultiplier: 1,
      touchMultiplier: 1.5,
    });
    lenisRef.current = lenis;

    lenis.on("scroll", ScrollTrigger.update);

    const onTick = (time) => lenis.raf(time * 1000);
    gsap.ticker.add(onTick);
    gsap.ticker.lagSmoothing(0);

    // Assicura che ScrollTrigger conosca la geometria dopo il mount.
    const refresh = () => ScrollTrigger.refresh();
    const t = setTimeout(refresh, 300);

    return () => {
      clearTimeout(t);
      gsap.ticker.remove(onTick);
      lenis.destroy();
      lenisRef.current = null;
    };
  }, []);

  return <LenisContext.Provider value={lenisRef}>{children}</LenisContext.Provider>;
}
